export type Testimonial = {
  quote: string
  author: string
  role: string
  avatar: string
}

/**
 * SAMPLE COPY — the product has no buyers yet.
 * Replace every quote, name and photo with a real buyer review (with
 * permission) before running traffic. US FTC rules prohibit fabricated reviews.
 * The first item is shown as the featured story.
 */
export const testimonials: Testimonial[] = [
  {
    quote:
      'I used to spend Sunday writing Monday’s session. Now I read the Run Sheet over coffee, pick the 3-hour formula and walk in ready. Four of my six drop-in players booked the next table before they left.',
    author: 'Marcus Hale',
    role: 'Paid GM · 3 weekly tables, Denver',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/f3bb7280-c655-4859-a920-df363c3bfd70.jpg',
  },
  {
    quote:
      'The Open Door ending is the rebook machine. Every session closes on a hook, and my players ask “when’s the next one?” without me selling anything.',
    author: 'Valeria Ortiz',
    role: 'Online GM on StartPlaying',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/6e5725de-83fb-4b3c-a53b-a7a4eabd507f.jpg',
  },
  {
    quote:
      'Table Kits saved my Thursday nights. Map, NPC voices and scaling by party size, all on one spread. I stopped flipping books mid-combat.',
    author: 'Darnell Brooks',
    role: 'Weekly campaign GM, Atlanta',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/16c4dad7-9e37-4fdd-9866-7e730cc8fb1a.jpg',
  },
  {
    quote:
      'I run from Foundry and every kit dropped right in. Twenty minutes of reading, zero tech scramble when strangers join.',
    author: 'Mei Tanaka',
    role: 'VTT GM, 2 online tables',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/16cc2876-8561-47c4-8cbe-5bf19de2051e.jpg',
  },
  {
    quote:
      'We host paid intro nights at the shop. The pre-gens get first-timers playing in two minutes, and those nights now fill a week ahead.',
    author: 'Tom Whitaker',
    role: 'Game store owner, Portland',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/4fb1d3d3-711d-4f46-94df-f5db686e60d2.jpg',
  },
  {
    quote:
      'The hobby vs. paid table page changed how I open. Clear hook, first roll in three minutes. My reviews went from “fun” to “booking again”.',
    author: 'Priya Raman',
    role: 'Paid GM · convention & one-shots',
    avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/63a2d5af-8230-4a25-93bc-5151e59008b8.jpg',
  },
]
